import axios from 'axios';
import { hostname } from './util';

export const check = () =>
  axios
    .get(`${hostname}/api/portal/auth`)
    .then((resp) => {
      if (resp.status === 200) {
        return {
          email: resp.data.email,
          name: resp.data.username,
          role: resp.data.role,
          customer: resp.data.customer,
        };
      }
      return false;
    })
    .catch(() => false);

export const login = ({ username, password }) =>
  axios
    .post(`${hostname}/api/portal/auth/login`, { username, password })
    .then((resp) => {
      if (resp.status === 200) {
        return {
          email: resp.data.email,
          name: resp.data.username,
          role: resp.data.role,
          customer: resp.data.customer,
        };
      }
      return false;
    })
    .catch((e) => {
      console.error('Failed to login', e?.response?.data?.error);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(
        e?.response?.data?.suggestion ||
          e?.response?.data?.error ||
          'Failed to login - incorrect credentials'
      );
    });

export const logout = () =>
  axios.post('/api/portal/auth/logout').then((resp) => resp.status === 200);
